import { Directive, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appEscapeListener]',
  standalone: true
})
export class EscapeListenerDirective {
  @Output() escape = new EventEmitter<void>();

  @HostListener('document:keyup', ['$event'])
  handleKeyEvent(event: KeyboardEvent): void {
    const target = event.target as HTMLElement;

    if (target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.tagName === 'SELECT') {
      return;
    }

    if (!event.altKey && !event.shiftKey && !event.ctrlKey && event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      this.escape.emit();
    }
  }
}
